import type { Customer } from '@/types/checkout';

export interface LocaleInfo {
  pspLocale: string;
  customLocale: string;
}

const DEFAULT_LOCALE = 'en';
const LOCALE_SEPARATOR = ';';

export const getLocale = (): LocaleInfo => {
  const searchParams = new URLSearchParams(window.location.search);
  const localeParam = searchParams.get('locale') || '';
  if (!localeParam) {
    return { pspLocale: DEFAULT_LOCALE, customLocale: DEFAULT_LOCALE };
  }

  const separatorIndex = localeParam.lastIndexOf(LOCALE_SEPARATOR);
  if (separatorIndex > -1) {
    const customLocale = localeParam.slice(0, separatorIndex);
    const pspLocale = localeParam.slice(separatorIndex + 1);
    return {
      pspLocale,
      customLocale,
    };
  }

  const locale = localeParam || DEFAULT_LOCALE;
  return {
    pspLocale: locale,
    customLocale: locale,
  };
};

export const isFromCalifornia = (customer: Customer) => {
  return customer.address?.state === 'CA';
};
